export default {
  "meeting": {
    applyrecurring: 'Các thay đổi sẽ được áp dụng cho lịch lặp mới. Các cuộc họp trước đó sẽ không bị ảnh hưởng.',
    recurrenceDescribeTwo: 'Lặp lại mỗi {loopPulse} tuần vào {week}, từ {start} đến {end}',
    wanttodeletethemeetingfollowTwo: 'Xóa cuộc họp đã chọn và tất cả các cuộc họp định kỳ tiếp theo?',
    loopCycleSelectTips: 'Vui lòng chọn ngày trong tuần để lặp lại.',

    export: 'Xuất',
    exportMeetingFileFuncTipsTitle: 'Xác nhận xuất',
    exportMeetingFileFuncTipsContentOne: 'Chưa áp dụng bộ lọc. Hệ thống sẽ mặc định xuất dữ liệu cuộc họp của năm hiện tại.',
    exportMeetingFileFuncTipsContentTwo: 'Để xuất cuộc họp trong khoảng thời gian khác, vui lòng áp dụng bộ lọc mong muốn trước khi xuất.',

    myMeetingSearch: 'Cuộc họp của tôi',
    meetingTimeSearch: 'Thời gian họp',
    meetingRoomsSearch: 'Phòng họp',

    Recurring: 'Lặp lại:',
    wanttodeletethemeetingfollow: 'Bạn có chắc chắn muốn xóa cuộc họp này và tất cả các cuộc họp tiếp theo không?',
    endTimeCannotBeforeBeginTime: 'Ngày kết thúc không thể sớm hơn ngày bắt đầu',
    Thismeeting: 'Cuộc họp này',
    Recurringmeeting: 'Cuộc họp lặp lại',
    Checkin: 'Điểm danh:',
    checkinTip: 'Sau khi bật, người tham dự có thể điểm danh bằng cách quét mã QR của hệ thống đặt phòng.',
    Recurrence_Setrecurrence: 'Thiết lập lặp lại',
    Recurrence_Start: 'Bắt đầu',
    Recurrence_RepeatEvery: 'Lặp lại mỗi',
    Recurrence_Week: 'Tuần',
    Recurrence_end: 'Kết thúc',
    recurrenceDescribe: 'Lặp lại mỗi {week} bắt đầu từ {start} đến {end}',
    Recurrence_DoesnotRepeat: 'Không lặp lại',
    Recurrence_Weekly: 'Hàng tuần',

    AddressBookUser: 'Người dùng',
    AddressBookPhonebook: 'Danh bạ',

    RoomByPeopleNum1: '2 người trở xuống',
    RoomByPeopleNum2: '3-6 người',
    RoomByPeopleNum3: '7-10 người',
    RoomByPeopleNum4: '11-15 người',
    RoomByPeopleNum5: '16-20 người',
    RoomByPeopleNum6: '21-30 người',
    RoomByPeopleNum7: 'Trên 30 người',

    whoAreBound: 'Người dùng đã liên kết tài khoản hệ thống sẽ thấy cuộc họp trong lịch hệ thống. Người dùng đã cung cấp email sẽ nhận thông báo qua email. Để nhận thông báo, vui lòng hoàn thiện thông tin trong [Hồ sơ của tôi].',

    AttendessMeeting: 'Người tham dự:',
    SelectAttendessMeetingTip: 'Chọn người tham dự',

    MeetingFilter: 'Bộ lọc cuộc họp',
    HostedbyMe: 'Tôi tổ chức',
    Invitedby: 'Tôi tham gia',
    Otherby: 'Khác',

    "AddressIsDuplicated": "Email liên hệ bị trùng lặp",
    "meetingExpired": "Đã hết hạn",
    titlePhoneFormat: 'Điện thoại chỉ có thể nhập số, () + và -.',
    "selectField": "Vui lòng chọn tệp",
    "Limit255": "Tên tệp không được vượt quá 255 ký tự",
    "nameLimit25": "Tên không được vượt quá 25 ký tự",
    "emailLimit50": "Email không được vượt quá 50 ký tự",
    "emailFormatError": "Vui lòng nhập địa chỉ email hợp lệ",
    "phoneLimit11": "Số điện thoại có thể chứa tối đa 11 chữ số",
    "ParticipantsEmail": "Email người tham gia:",
    "listIsEmpty": "Danh sách trống",
    "Startimporting": "Bắt đầu tải lên",
    "Selectfile": "Chọn tệp",
    "Importfile": "Nhập tệp",
    "ImportfileTip": "*Chỉ hỗ trợ nhập tệp CSV định dạng Outlook (.csv) hoặc tệp vCard (.vcf).",
    "addParticipants": "Thêm người tham gia",
    "multiselectdeselect": "Gợi ý xóa nhãn",
    "multiselectselected": "Gợi ý đã chọn",
    "enterOrSelectALabel": "Chọn email người tham gia",
    "deleTitleContact": "Bạn có chắc chắn muốn xóa liên hệ này không?",
    "delTitleContactContent": "Xóa liên hệ?",
    "deleteContactTitle": "Vui lòng chọn liên hệ muốn xóa",
    "editcontact": "Chỉnh sửa liên hệ",
    "Name": "Tên",
    "email": "Email",
    "telephoneNumber": "Điện thoại",
    "Addcontact": "Thêm liên hệ",
    "Importcontactfile": "Nhập liên hệ",
    "AddressBook": "Sổ địa chỉ",
    "Participants": "Người tham gia:",

    bindTipContent:"Tổ chức này đã liên kết với lịch của bên thứ ba. Vui lòng lên lịch họp qua Outlook/Teams.",
    Productupdatenews: 'Đã phát hành bản cập nhật phiên bản mới. ',
    bookingPerson: 'Được đặt bởi',
    "DeleteMeeting": "Xóa cuộc họp",
    "wanttodeletethemeeting": "Bạn có muốn xóa cuộc họp không?",
    "hasbeendeleted": "Cuộc họp đã bị xóa",
    "theMeetingWasAborted": "Kết thúc cuộc họp sớm",
    "theMeetingWasAbortedContent": "Bạn có muốn kết thúc cuộc họp sớm không?",
    "determineTheAbortTask": "Kết thúc cuộc họp sớm",
    "theMeetingEndedEarly": "Cuộc họp đã kết thúc sớm.",
    "with": "với",
    "Other": "Khác",
    "tasks": "xung đột công việc",
    "conflict": "Thời gian cuộc họp sau đây xung đột:",
    "meetConflicts": "Không thể chọn thời gian trong quá khứ",
    "itIsNotAllowedToSelectThePastTime": "Đã chọn",
    "selected": "Chọn không quá 5 phòng họp",
    "noOverFive": "Ý kiến phê duyệt",
    "approvalOpinions": "Vượt quá thời gian giới hạn, không thể chọn",
    "beyondTheTimeLimitItCannotBeSelected": "Tháng bắt đầu",
    "startMonth": "đến",
    "to": "Tháng kết thúc",
    "stopMonth": "Không có bắt đầu",
    "didnTStart": "Đang diễn ra",
    "ONGOING": "Đã kết thúc",
    "ENDED": "đã có",
    "hasBeen": "đặt chỗ",
    "booking": "Phê duyệt",
    "Approval": "Phòng họp",
    "MeetingRoom": "Tất cả phòng",
    "AllRoom": "Có sẵn",
    "Available": "Khởi động cuộc họp",
    "Initiate": "Phê duyệt cuộc họp",
    "MeetingApproval": "Tháng trước",
    "PreviousMonth": "Hôm nay",
    "Today": "Tháng sau",
    "NextMonth": "Năm/Tháng",
    "YearMonth": "Hiển thị thời gian",
    "TimeDisplay": "Tên viết tắt của cuộc họp",
    "MeetingTitleAbbreviation": "Khởi động cuộc họp",
    "InitiateMeeting": "Các cuộc họp sắp tới",
    "PendingMeetings": "Tất cả các cuộc họp",
    "AllMeetings": "Hiện tại không có cuộc họp nào để tham gia",
    "noMeetings": "Chưa bắt đầu",
    "NotStarted": "Người tổ chức",
    "Organizer": "Ngày & Giờ",
    "MeetingDateTime": "Vị trí",
    "MeetingLocation": "Chủ đề cuộc họp",
    "MeetingSubject": "Người được mời",
    "Invited": "Người chấp nhận",
    "PeopleAccepted": "Chỉnh sửa cuộc họp",
    "EditMeeting": "Hủy cuộc họp",
    "CancelMeeting": "Khởi động/Chỉnh sửa cuộc họp",
    "InitiateEditMeeting": "Chủ đề",
    "Subject": "Chủ đề",
    "Presenter": "Người trình bày :",
    "DateTime": "Ngày và Giờ",
    "TimeAndZone": "Múi giờ",
    "Attendees": "Người tham gia",
    "Addrequiredattendees": "Thêm người tham gia cần thiết",
    "SelectRooms": "Chọn phòng",
    "Reminder": "Lời nhắc",
    "Remindbeforestart": "Nhắc nhở trước khi bắt đầu",
    "Confirm": "Xác nhận",
    "topic": "Chủ đề :",
    "topicplace": "Tiêu đề cuộc họp mới :",
    "speaker": "Người trình bày :",
    "speakerplace": "Vui lòng nhập thông tin của người trình bày",
    "DateAndTime": "Ngày và Giờ :",
    "TimeZone": "Múi giờ",
    "EndDate": "Ngày kết thúc",
    "Rooms": "Phòng :",
    "Notes": "Ghi chú :",
    "MeetingRoomApproval": "Phê duyệt phòng họp",
    "PendingApproval": "Đang chờ phê duyệt",
    "Approved": "Đã phê duyệt",
    "nopendingapprovals": "Không có phê duyệt nào đang chờ",
    "Applicant": "Người yêu cầu",
    "UsageTime": "Thời gian sử dụng",
    "ApprovalResult": "Kết quả phê duyệt",
    "ApprovalComments": "Nhận xét về phê duyệt",
    "Approve": "Phê duyệt",
    "Reject": "Từ chối",
    "Search": "Tìm kiếm",
    "Filter": "Lọc",
    "scanTheQRCodeToSignIn": "Quét mã QR để đăng nhập"
  },
  "NPS": {
    "Relay": "Rơ le",
    "RelaySettings": "Cài đặt Rơ le",
    "DevicePower": "Điều khiển nguồn thiết bị",
    "DeviceElevation": "Điều khiển nâng hạ",
    "LinageWithNPSPower": "Liên kết với nguồn NPS",
    "PresentationSwitch": "Công tắc trình bày",
    "Duplicate": "Nhân bản",
    "LinkagewithNPSPowe": "Liên kết với nguồn NPS",
    "npsTooltip": "Thiết bị USB chỉ có thể được gọi bởi PC host được chuyển sang HDMI OUT 1.",
    "nmpTooltip": "Nhấp vào nút 'Nhân bản' để phản chiếu nội dung màn hình trên các màn hình khác, đồng bộ hóa hiển thị trên nhiều màn hình."
  },
  "textTemplate": {
    "template2513": "Truyền hình khẩn cấp cháy",
    "template2514": "Vui lòng di tản ra ngoài qua cửa thoát hiểm và cửa thoát hỏa hoạn đến nơi an toàn theo kế hoạch thoát hiểm cháy.",
    "moreTemplate": "Đã đạt giới hạn mẫu",
    "add": "Thêm",
    "SetTemplate": "Cài đặt mẫu",
    "Emergency": "Khẩn cấp",
    "General": "Chung",
    "BroadcastDevices": "Thiết bị phát sóng:",
    "selectBroadcastDevices": "Vui lòng chọn thiết bị phát sóng",
    "All": "Tất cả",
    "AddTemplate": "Thêm mẫu",
    "EditTemplate": "Chỉnh sửa mẫu",
    "deleteTemplage": "Bạn có chắc chắn muốn xóa mẫu đã chọn không?",
    "title": "Xóa mẫu",
    "selectTemplage": "Vui lòng chọn một mẫu!",
    "DeleteCancelled": "Hủy xóa!",
    "DeletedSuccessfully": "Đã xóa thành công!",
    "noData": "Không thể sử dụng mẫu, hãy nhấp vào góc phải trên để thêm mẫu.",
    "TemplateTitle": "Tiêu đề mẫu:",
    "BroadcastType": "Loại phát sóng:",
    "BroadcastTypeDialog": "Loại phát sóng:",
    "selectBroadcastType": "Vui lòng chọn loại phát sóng",
    "BroadcastDuration": "Thời gian phát sóng:",
    "BroadcastDevice": "Thiết bị phát sóng:",
    "BroadcastContent": "Nội dung phát sóng:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Lỗi!",
    "mediaTimeStateNotifyErrorContent": "Dịch vụ phát sóng của bạn đã hết hạn, vui lòng liên hệ với đại lý của bạn để gia hạn kịp thời.",
    "mediaTimeStateNotifyWarnTitle": "Lưu ý!",
    "mediaTimeStateNotifyWarnContent": "Hiện tại bạn đang trong chế độ thử nghiệm và chỉ có thể phát sóng và phát trực tiếp tối đa trên 3 thiết bị đầu cuối.",
    "mediaTimeStateNotifySuccessTitle": "Gia hạn thành công",
    "mediaTimeStateNotifySuccessContent": "Dịch vụ phát sóng của bạn đã sẵn sàng sử dụng bình thường. Cảm ơn bạn.",
    "company": "Tên công ty:",
    "tableAddress": "Địa chỉ:",
    "createTime": "Ngày tạo:",
    "email": "Email:",
    "phone": "Số điện thoại:",
    "Trial": "Thử nghiệm",
    "TrialWorkstation": "Hiện tại bạn đang trong chế độ thử nghiệm và chỉ có thể phát sóng và phát trực tiếp tối đa trên 3 thiết bị đầu cuối.",
    "Normal": "Bình thường",
    "NormalWorkstation": "Thời gian hiệu lực của dịch vụ phát sóng của bạn từ",
    "to": "đến",
    "Advent": "Sắp hết",
    "AdventWorkstationOne": "Dịch vụ phát sóng của bạn sẽ hết hạn vào",
    "AdventWorkstationTwo": ", vui lòng liên hệ với đại lý của bạn để gia hạn kịp thời.",
    "Expired": "Hết hạn",
    "ExpiredWorkstation": "Dịch vụ phát sóng của bạn đã hết hạn, vui lòng liên hệ với đại lý của bạn để gia hạn kịp thời."
  },
  "route": {
    "dashboard": "Bảng điều khiển",
    "i18n": "I18n",
    "Devices": "Thiết bị",
    "Broadcast": "Phát sóng",
    "Schedule": "Lịch trình",
    "Resources": "Tài nguyên",
    "Live": "Trực tiếp",
    "meetings": "Cuộc họp"
  },
  "navbar": {
    "updates":"Cập nhật mới nhất",
    "logOut": "Đăng xuất",
    "screenfull": "Toàn màn hình",
    "oprofile": "Hồ sơ của tôi",
    "settings": "Cài đặt",
    "language": "Ngôn ngữ",
    "BackTianwa": "Quay lại Tianwa",
    "newUserGuide": "Hướng dẫn người dùng mới"
  },
  "feedback": {
    "Feedback": "Phản hồi",
    "email": "Vui lòng để lại email của bạn để nhận phản hồi.",
    "content": "Chào mừng và để lại tin nhắn để cải thiện sản phẩm của chúng tôi. Cảm ơn bạn đã gửi ý kiến.",
    "submit": "Gửi",
    "emailNoEmpty": "Email không được để trống",
    "emailTrueRule": "Vui lòng nhập đúng định dạng email",
    "contentNoEmpty": "Nội dung không thể để trống",
    "feedbackSuccess": "Phản hồi thành công",
    "feedbackFailed": "Phản hồi thất bại",
    "emailNoChinese": "Hộp thư không thể chứa ký tự tiếng Trung",
    "emailLength": "Độ dài từ 5 đến 50 ký tự",
    "emailSpecialString": "Hộp thư không thể chứa chuỗi đặc biệt"
  },
  "login": {
    checkPasswordTitleTwo: 'Vui lòng đặt mật khẩu ít nhất 6 ký tự, bao gồm chữ cái và số. Có thể sử dụng ký tự đặc biệt (không giới hạn).',
    captcha: 'Mã xác minh',
    checkPasswordTitle: 'Mật khẩu phải có ít nhất 6 ký tự và không được chỉ toàn số',
    "title": "CHÀO MỪNG",
    "logIn": "Đăng nhập",
    "consoleLogin": "Đăng nhập vào bảng điều khiển",
    "username": "Tên người dùng",
    "password": "Mật khẩu",
    "any": "bất kỳ",
    "thirdparty": "Hoặc đăng nhập với",
    "thirdpartyTips": "Không thể mô phỏng tại địa phương, vui lòng kết hợp với mô phỏng kinh doanh của bạn!",
    "placeholder": ["Tên người dùng","Mật khẩu","Mã xác minh"],
    "userNameTitle": "Tên người dùng sai!",
    "forget": "Quên rồi?",
    "loginTitle0": "Đăng nhập thành công!",
    "loginTitle1000": "Tên người dùng hoặc mật khẩu sai!",
    "loginTitle1001": "Tên người dùng và mật khẩu phải được điền đầy đủ!",
    "loginTitle1002": "Mã xác minh phải được điền đầy đủ!",
    "loginTitle1003": "Trạng thái người dùng là bất hợp pháp, đăng nhập thất bại!",
    "loginTitle1004": "Lỗi mã xác minh!",
    "loginTitle1005": "Chưa đăng nhập, vui lòng đăng nhập trước!",
    "loginTitle1006": "Mật khẩu không khớp!",
    "loginTitleUserName": "Tên người dùng phải được điền đầy đủ!",
    "loginTitlePwd": "Mật khẩu phải được điền đầy đủ!",
    "loginTitleVercode": "Mã xác minh phải được điền đầy đủ!",
    "titleLoginNameFormat": "Tài khoản phải bao gồm ký tự hoặc ký tự và số.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Thiết bị",
    "btnRoadcast": "Phát sóng",
    "btnResources": "Tài nguyên",
    "btnLive": "Trực tiếp",
    "meetings": "Cuộc họp",
    "todaySchedule": "Lịch hôm nay",
    "allSkedules": "Tất cả lịch trình",
    "details": "Chi tiết",
    "btnStart": "Bắt đầu",
    "titleContent": "Xin chào! Bảng điều khiển Q-NEX đang phục vụ bạn. Chúng ta hãy bắt đầu!",
    "btnExit": "Thoát"
  },
  "devices": {
    ptzCamera:'Máy quay PTZ',
    "start": "BẮT ĐẦU",
    "stop": "DỪNG LẠI",
    "nmpPowerOff_mandatory": "Đang phát sóng (không bắt buộc)",
    "nmpPowerOff_nomandatory": "Đang phát sóng (không bắt buộc). Tiếp tục thực thi?",
    "nmpsPowerOff_mandatory": "Một số NMP đang phát sóng (bắt buộc).",
    "nmpsPowerOff_nomandatory": "Một số NMP đang phát sóng (không bắt buộc). Tiếp tục thực thi?",
    "reset": "Đặt lại",
    "displayedInTheControlArea": "Hiển thị trong trung tâm điều khiển",
    "dragOrder": "Kéo thứ tự",
    "areaSettingTwoNotice": "*Điều khiển RS232, AC và điều khiển từ xa được hiển thị trong trung tâm điều khiển tùy thuộc vào trạng thái liên kết NMP trong bảng điều khiển.",
    "areaSettingThreeNotice": "*Điều khiển CBX được hiển thị trong trung tâm điều khiển tùy thuộc vào trạng thái liên kết NMP trong bảng điều khiển.",
    "controlSet": "Cài đặt trung tâm điều khiển",
    "vcbNoLine": "Không có thiết bị CBX trực tuyến",
    "vcbNoBound": "Không có thiết bị CBX liên kết",
    "tscNoBound": "RS232 trên TSC không liên kết với bất kỳ dữ liệu nào. Vui lòng thông báo cho quản trị viên để liên kết trong bảng điều khiển.",
    "light": "Điều khiển năng lượng",
    "vcbpower": "Năng lượng",
    "rs232Control": "Điều khiển Serial",

    "CBX":  {
    "powerSupplyON": "Bật nguồn",
    "powerSupplyOFF": "Tắt nguồn",
    "lockScreenON": "Khóa",
    "lockScreenOFF": "Mở khóa",
    "childLockON": "Khóa trẻ em bật",
    "childLockOFF": "Khóa trẻ em tắt",
    "energySavingON": "Chế độ tiết kiệm năng lượng bật",
    "energySavingOFF": "Chế độ tiết kiệm năng lượng tắt",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Loa",
    "brightAdjustment": "Độ sáng",
    "other": "Các tính năng khác..."
  },

    "InterfaceOne": "Giao diện Một",
    "InterfaceTwo": "Giao diện Hai",
    "abcStyleP": "Xin lỗi! TSC và (NMP, MBX, NPS, NDP100, NDP500) không thể chọn cùng lúc",
    "masterControl": "chính",
    "powerSupply": "Nguồn điện",
    "RecordingControl": "Kiểm soát ghi âm",
    "RecordingControlSystem": "Hệ thống ghi lại bài giảng",
    "LiquidCrystal": "Màn hình LCD tương tác",
    "projector": "Máy chiếu",
    "othertype": "Khác",
    "lockScreen": "Khóa",
    "childLock": "Khóa trẻ em",
    "energySaving": "Tiết kiệm năng lượng",
    "signalSourceSwitching": "Nguồn vào",
    "volumeAdjustment": "Loa",
    "brightAdjustment": "Độ sáng",
    "other": "Các tính năng khác",
    "otherFunction": "Chức năng",
    "send": "Gửi",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Điều hòa",
    "titleDevices": "Bộ lọc nhóm:",
    "content": "Tìm kiếm",
    "selectALL": "Chọn TẤT CẢ",
    "SelectRecentPage": "Chọn Trang hiện tại",
    "controlPanel": "Trung tâm điều khiển",
    "displayInputSwitch": "Chuyển đổi đầu vào hiển thị",
    "chooseINPUTSources": "Chọn nguồn vào",
    "speakerVolume": "Âm lượng âm thanh",
    "bass": "Âm trầm",
    "treble": "Âm cao",
    "MICVolume": "Âm lượng MIC",
    "AirConditioning": "Điều hòa không khí",
    "model": "Mẫu",
    "setTemp": "Nhiệt độ cài đặt",
    "fanSpeed": "Tốc độ quạt",
    "bold": "Xoay",
    "projectionScreen": "Màn hình chiếu",
    "electronicLock": "Khóa điện",
    "electronicLock1": "Khóa điện",
    "selectDevices": "Vui lòng chọn thiết bị hoặc nhóm thiết bị",
    "isCompelType": "Không thể điều khiển thiết bị do phát sóng bắt buộc, vui lòng thử lại sau.",
    "mainPower": "Nguồn chính",
    "extraPower": "Nguồn phụ",
    "power": "Nguồn",
    "hdmiBroadcast": "Phát sóng",
    "equipmentState1": "Bật",
    "equipmentState2": "Tắt",
    "equipmentState3": "Ngoại tuyến",
    "main": "Chính",
    "external": "Ngoài",
    "ProjectionScreen": "Màn hình chiếu",
    "UP": "LÊN",
    "DOWN": "XUỐNG",
    "LOCK": "KHÓA",
    "UNLOCK": "MỞ KHÓA",
    "PleaseDevice": "Vui lòng chọn thiết bị(s) ở bên trái",
    "RemoteControl": "Điều khiển từ xa",
    "Action": "Hành động",
    "Devicefilter": "Bộ lọc thiết bị",
    "DeviceStatus": "Tình trạng",
    "DeviceType": "Loại",
    "currentAudioSource": "Nguồn âm thanh hiện tại",
    "audioSwitching": "Công tắc đầu ra âm thanh"
  },
  "broadcast": {
    "isBoarding": "(Đang phát sóng)",
    "last3Days": "3 NGÀY CUỐI",
    "last7Days": "7 NGÀY CUỐI",
    "last30Days": "30 NGÀY CUỐI",
    "historyRecord": "Lịch sử",
    "SelectDestination": "1.Chọn đích đến",
    "BroadcastingConsole": "2.Bảng điều khiển phát sóng",
    "Notification": "Thông báo",
    "btnStop": "Dừng",
    "btnStart": "Bắt đầu",
    "Letters60": "(không quá 60 ký tự)",
    "Letters300": "(không quá 300 ký tự)",
    "LastingTime": "Thời gian kéo dài:",
    "Title": "Tiêu đề:",
    "Content": "Nội dung:",
    "Cannotquit": "Phát sóng bắt buộc",
    "ChooseMedia": "Chọn một tệp phương tiện",
    "Broadcasting": "Phát sóng",
    "dialogTitle": "Tài nguyên video và âm thanh",
    "SortBy": "Sắp xếp theo",
    "btnBake": "Quay lại trang trước",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "coxAll": "Tất cả",
    "PublicCloud": "Lưu trữ công cộng",
    "IndividualCloud": "Lưu trữ cá nhân",
    "selFile": "Vui lòng chọn tệp hoặc nhóm.",
    "StopBroadcast": "Dừng phát sóng",
    "StartBroadcasting": "Bắt đầu phát sóng",
    "StopBroadcasting": "Dừng phát sóng",
    "ForceQuit": "Buộc thoát",
    "PleaseMediaFile": "Vui lòng chọn tệp phương tiện",
    "PleaseDevice": "Vui lòng chọn thiết bị",
    "broadcast_0": "Bắt đầu phát sóng",
    "broadcast_2500": "Vượt quá số lượng thiết bị kết nối tối đa cho máy chủ phương tiện",
    "broadcast_2501": "Lỗi tệp phát sóng",
    "broadcast_2502": "Phát sóng đã kết thúc",
    "broadcast_2503": "Không thể lấy thông tin từ máy chủ phương tiện",
    "broadcast_2510": "Chú ý! Bạn hiện đang trong trạng thái dùng thử, tối đa 3 thiết bị đầu cuối có thể nhận lệnh phát sóng. Vui lòng kiểm tra số lượng thiết bị bạn đã chọn.",
    "broadcast_2018": "Dịch vụ phát sóng đã bị tắt",
    "broadcast_2019": "Dịch vụ phát sóng đã hết hạn",
    "broadcast_2512": "Vượt quá giới hạn số lượng mẫu",
    "broadcast_2513": "Phát sóng khẩn cấp trường hợp hỏa hoạn",
    "broadcast_2514": "Vui lòng sơ tán từ cửa thoát hiểm và cửa thoát hỏa vào nơi an toàn theo kế hoạch thoát hỏa",
    "broadcast_2006": "Không tìm thấy thiết bị",
    "broadcast_2": "Dịch vụ ổ đĩa bất thường",
    "broadcast_2515": "Chọn thiết bị không có khả năng phát sóng",
    "broadcast_2516": "Chọn các tệp vượt quá độ phân giải tối đa được hỗ trợ của NMP",
    "broadcast_2517": "Chọn các tệp vượt quá độ phân giải tối đa được hỗ trợ của NDP500",
    "broadcast_Title": "Cảnh báo phát sóng",
    "broadcast_TitleNDP500": "Cảnh báo phát sóng NDP500",
    "broadcast_content": "Thiết bị hỗ trợ lên đến 4K@30FPS, với độ phân giải tối ưu là 1080P@30FPS",
    "broadcast_contentNDP500": "NDP500/600 hỗ trợ lên đến 1080P@30FPS, với độ phân giải tối ưu là 720P@30FPS",
    "broadcast_noSupported": "Các video đã chọn sau đây không được hỗ trợ cho việc phát sóng:",
    "broadcast_noSupportedNDP500": "Các video đã chọn sau đây không được hỗ trợ cho việc phát sóng trên NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "Tên tệp tải lên không thể vượt quá 100 từ!",
    "onUploadFile": "Không có tệp để tải lên",
    "open": "Mở",
    "fold": "Gập lại",
    "close": "Đóng",
    "PublicCloud": "Lưu trữ công cộng",
    "IndividualCloud": "Lưu trữ cá nhân",
    "TransfersHistory": "Lịch sử chuyển giao",
    "btnDownload": "Tải xuống",
    "btnDelete": "Xóa",
    "btnUploadFile": "Tải lên tệp",
    "btnNewFolder": "Thư mục mới",
    "btnBake": "Quay lại trang trước",
    "coxAll": "Tất cả",
    "uploadError": "Kích thước tệp tải lên không thể vượt quá 1GB!",
    "MD5": "Xác minh MD5",
    "merge": "Hợp nhất",
    "transcoding": "Chuyển mã",
    "uploadFailed": "Tải lên thất bại",
    "fileError": "Lỗi đọc tệp, vui lòng kiểm tra tệp",
    "tableName": "Tên",
    "tableSize": "Kích thước",
    "tableType": "Loại",
    "tableTimeAdded": "Thời gian thêm",
    "tableAction": "Hành động",
    "btnRename": "Đổi tên",
    "btnMoveTo": "Di chuyển đến...",
    "ClearAll": "Xóa tất cả",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm thất bại!",
    "editSuccess": "Sửa thành công!",
    "editError": "Sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "diskError3000": "Vượt quá tổng kích thước không gian, thao tác không thành công!",
    "diskError3001": "Vượt quá dung lượng không gian công cộng đã sử dụng, thao tác không thành công!",
    "diskError3002": "Vượt quá dung lượng không gian cá nhân đã sử dụng, thao tác không thành công!",
    "diskError3003": "Không thể tìm thấy dữ liệu, vui lòng kiểm tra xem máy chủ phương tiện có được liên kết không!",
    "diskError3004": "Tên thư mục đã tồn tại!",
    "diskError3005": "Lỗi khi lấy thư mục!",
    "diskError3006": "Không thể tạo quá 99 thư mục cùng cấp!",
    "diskError3007": "Tên tệp đã tồn tại và thay đổi không thành công!",
    "diskError3008": "Tên thư mục đã tồn tại và thay đổi không thành công!",
    "diskError3009": "Tệp vượt quá không gian còn lại và tải lên thất bại!",
    "diskError3010": "Tải lên thất bại!",
    "diskError3011": "Lỗi xác minh tệp, vui lòng tải lại tệp!",
    "diskError3012": "Lỗi khi lấy địa chỉ đám mây riêng, thao tác thất bại!",
    "diskError3013": "Các tổ hợp tệp không được vượt quá 100MB, các tệp lớn vui lòng tải riêng biệt!",
    "diskError3014": "Nén tệp thất bại, vui lòng chọn lại tệp để tải xuống!",
    "diskError3015": "Bạn cần quyền để thực hiện thao tác này",
    "downloadError": "Tải xuống thất bại!",
    "mobileError": "Di chuyển thất bại!",
    "root": "Tất cả các tệp",
    "Name": "Tên",
    "Size": "Kích thước",
    "Type": "Loại",
    "uploadFile": "Tải lên tệp",
    "newFolder": "Thư mục mới",
    "tableTime": "Thời gian",
    "permission": "Không đủ quyền!",
    "notifyTitle": "Thông báo",
    "notifyContent": "Người dùng không có quyền truy cập đầy đủ!",
    "sortFileName": "Tên tệp",
    "sortTime": "Thời gian",
    "sortSize": "Kích thước",
    "sortType": "Loại",
    "moveTo": "Di chuyển tới",
    "test": "Mới",
    "delTitle": "Xóa?",
    "delTitleContent": "Nội dung đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Thao tác không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục không?",
    "delCancelButton": "Hủy",
    "delConfirmButton": "Xác nhận"
  },
  "userMge": {
    "userName": "Tên người dùng:",
    "jobNumber": "Mã nhân viên:",
    "email": "Email:",
    "phone": "Điện thoại:",
    "group": "Nhóm:",
    "oldPassword": "Mật khẩu cũ:",
    "newPassword": "Mật khẩu mới:",
    "confirmNewPassword": "Xác nhận mật khẩu mới:",
    "btnSave": "Lưu thay đổi",
    "titleChangePassword": "Đổi mật khẩu",
    "titleMyProfile": "Hồ sơ của tôi",
    "name": "Biệt danh:",
    "error1400": "Tài khoản (tùy chỉnh) đã tồn tại, thao tác thất bại!",
    "error1401": "Tài khoản (hệ thống tạo) đã tồn tại, thao tác thất bại!",
    "error1402": "Nhóm không tồn tại, nhập khẩu thất bại!",
    "error1403": "Lỗi dữ liệu",
    "error1404": "Quyền hạn không đủ",
    "selUser": "Vui lòng chọn người dùng!",
    "error1405": "Không thể lấy vai trò",
    "error1406": "Định dạng dữ liệu thông tin người dùng nhập khẩu sai",
    "error1407": "Email đã tồn tại và thao tác thất bại.",
    "error1408": "Số điện thoại đã tồn tại và thao tác thất bại.",
    "editSuccess": "Lưu thành công!",
    "ChangePassword": "Đổi mật khẩu",
    "UserPrivacyAgreement": "Chính sách quyền riêng tư của người dùng"
  },
  "information": {
    "_2602": "Thiết bị ngoại tuyến",
    "_2603": "Truyền phát thất bại",
    "_2604": "Truyền phát đã bị cắt đứt",
    "_2605": "Không gian lưu trữ đầy",
    "_2606": "vài phút trước",
    "_2607": "vài giờ trước",
    "_2609": "thất bại, vui lòng ",
    "_2609_a": "nhấp vào đây ",
    "_2609_time": "để xử lý kịp thời",
    "userType": "Quản trị viên",
    "unreadNoticeFirst": "Đọc thông báo trước",
    "sortByTime": "Sắp xếp theo thời gian",
    "coxRead_1": "Đã đọc",
    "coxRead_0": "Chưa đọc",
    "allCoxRead": "Đánh dấu tất cả là đã đọc",
    "load": "Đang tải...",
    "noData": "Không có thêm dữ liệu",
    "viewALLMessages": "Xem TẤT CẢ tin nhắn"
  },
  "input": {
    "select": "Vui lòng chọn",
    "thisField": "Trường này phải được điền.",
    "titleShooleNub60": "ít hơn 60 ký tự",
    "titleShooleNub300": "ít hơn 300 ký tự",
    "Offline": "Ngoại tuyến"
  },
  "schedule": {
    "OnlyManual": "Chỉ thủ công",
    "runStartNow": "Chạy nhiệm vụ",
    "runStopNow": "Dừng nhiệm vụ",
    "tackExecutionStart": "Nhiệm vụ đang chạy",
    "tackExecutionStop": "Dừng thực hiện nhiệm vụ",
    "dehumidification": "Khử ẩm",
    "airSupply": "Cung cấp không khí",
    "masterControl": "chính:",
    "powerSupply": "Nguồn",
    "lockScreen": "Khóa",
    "RecordingControl": "Điều khiển ghi âm",
    "RecordingControlSystem": "Hệ thống ghi lại bài giảng",
    "LiquidCrystal": "Màn hình LCD tương tác",
    "projector": "Máy chiếu",
    "othertype": "Khác",
    "childLock": "Khóa trẻ em",
    "energySaving": "Tiết kiệm năng lượng",
    "signalSourceSwitching": "Nguồn vào",
    "other": "Các tính năng khác:",
    "otherFunction": "Chức năng",
    "send": "Gửi",
    "ON": "BẬT",
    "OFF": "TẮT",
    "btnAddSchedule": "Khôi phục",
    "EditSchedulelist": "Chỉnh sửa lịch trình",
    "AddSchedulelist": "Thêm lịch trình",
    "RestoreSchedulelist": "Khôi phục",
    "btn": "Hủy bỏ",
    "btnNewList": "Lịch trình mới",
    "ListName": "Tên",
    "Cannotquit": "Bắt buộc",
    "NOCannotquit": "KHÔNG",
    "ListValidityPeriod": "Thời gian hiệu lực",
    "ListDescription": "Mô tả",
    "currentSchedule": "Danh sách lịch trình",
    "historySchedule": "Danh sách lịch sử",
    "selectTime": "Thời gian",
    "selectTimeTable": "Thời gian",
    "taskType": "Loại công việc",
    "selectBroadcasting": "Phát sóng",
    "selectDeviveControl": "Điều khiển thiết bị",
    "newSchedule": "Nhiệm vụ mới",
    "newChecklist": "Danh sách kiểm tra mới",
    "titleStatus": "Trạng thái",
    "titleType": "Loại",
    "titleStartTime": "Thời gian bắt đầu",
    "titleEndTime": "Thời gian kết thúc",
    "titleRepeat": "Lặp lại",
    "titleName": "Tên",
    "titleAction": "Hành động",
    "tableEnabled": "Bật",
    "tablePaused": "Tạm dừng",
    "tableEdit": "Chỉnh sửa",
    "tableDelete": "Xóa",
    "tableVolumeEdit": "Âm lượng phát sóng",
    "tableBroadcastTitle": "Tiêu đề",
    "tableBroadcastContent": "Nội dung",
    "tableBroadcastList": "Danh sách",
    "tableBroadcast": "Bắt buộc",
    "btnRemoveCompletely": "Xóa hoàn toàn",
    "btnEnabled": "Nhiệm vụ đã bật",
    "btnPaused": "Tắt nhiệm vụ",
    "btnDelete": "Xóa",
    "repeat0": "T2",
    "repeat1": "T3",
    "repeat2": "T4",
    "repeat3": "T5",
    "repeat4": "T6",
    "repeat5": "T7",
    "repeat6": "CN",
    "dialogTitleAdd": "Nhiệm vụ điều khiển thiết bị mới",
    "dialogTitleEdit": "Chỉnh sửa nhiệm vụ điều khiển thiết bị",
    "newBroadcastingSchedule": "Nhiệm vụ phát sóng mới",
    "editBroadcastingSchedule": "Chỉnh sửa nhiệm vụ phát sóng",
    "chooseDevice": "Chọn thiết bị",
    "timeSetting": "Cài đặt thời gian",
    "controlBroadcasting": "Tùy chọn phát sóng",
    "controlOption": "Tùy chọn điều khiển",
    "scheduleName": "Tên nhiệm vụ:",
    "destination": "Điểm đến",
    "timeTilte": "Thời gian",
    "repeatTitle": "Lặp lại",
    "dialogRepeat0": "T2",
    "dialogRepeat1": "T3",
    "dialogRepeat2": "T4",
    "dialogRepeat3": "T5",
    "dialogRepeat4": "T6",
    "dialogRepeat5": "T7",
    "dialogRepeat6": "CN",
    "dialogOnceType": "Một lần",
    "dialogRepeatType": "Lặp lại",
    "Manual": "Thủ công",
    "ManualContent": "Bạn có thể thực hiện các nhiệm vụ này thủ công khi hoàn tất cấu hình.",
    "mainPower": "Công suất chính",
    "powerControl": "Điều khiển năng lượng",
    "tableDisplayInputSwitch": "Chuyển đổi đầu vào hiển thị",
    "tableAirConditioning": "Điều hòa không khí",
    "tableProjectionScreen": "Màn chiếu",
    "tableElectronicLock": "Khóa điện",
    "interactiveFlatPanel": "Màn hình phẳng tương tác",
    "displayInputSwitch": "Chuyển đổi đầu vào hiển thị",
    "speakerVolume": "Âm lượng",
    "MICVolume": "Âm lượng mic",
    "ProjectionScreen": "Màn chiếu",
    "ElectronicLock": "Khóa điện",
    "AirConditioning": "Điều hòa không khí",
    "AirConditioningPower": "Công suất",
    "AirConditioningModel": "Mẫu",
    "AirConditioningTEMP": "Nhiệt độ",
    "AirConditioningFanSpeed": "Tốc độ quạt",
    "OPEN": "Mở",
    "CLOSE": "Đóng",
    "UP": "Lên",
    "DOWN": "Xuống",
    "PowerOFF": "Tắt",
    "PowerON": "Bật",
    "ModelAuto": "Tự động",
    "ModelCool": "Làm mát",
    "ModelHeat": "Làm nóng",
    "ModelAir": "Bên không khí",
    "TEMPLow": "Thấp",
    "TEMPMiddle": "Trung bình",
    "TEMPHigh": "Cao",
    "btnSave": "Lưu",
    "btnNext": "TIẾP THEO",
    "StartTime": "Thời gian bắt đầu",
    "StopTime": "Thời gian kết thúc",
    "Mandatory": "Bắt buộc",
    "Video": "Video và Âm thanh",
    "Notification": "Thông báo",
    "btnFile": "Chọn một tệp phương tiện",
    "LastingTime": "Thời gian kéo dài",
    "textTitle": "Tiêu đề",
    "textContent": "Nội dung",
    "textTitleLetters": "Ít hơn 60 ký tự",
    "textContentLetters": "Ít hơn 320 ký tự",
    "CannotquitYES": "CÓ",
    "CannotquitNo": "Không",
    "YES": "Bạn có chắc chắn muốn xóa lịch trình này không?",
    "No": "Lịch trình bị xóa sẽ được chuyển sang danh sách lịch sử và có thể được khôi phục",
    "delTitleContent": "Xóa lịch trình?",
    "delTitleListContent": "Việc xóa lịch trình sẽ khiến các nhiệm vụ liên quan bị xóa, vui lòng xác nhận.",
    "deleListTitle": "Bạn có chắc chắn muốn xóa lịch trình này không?",
    "delTitleListContent1": "Xóa?",
    "deleListTitle1": "Xác nhận",
    "delTitle": "TẤT CẢ",
    "btnConfirm": "Phát sóng",
    "coxAll": "Điều khiển thiết bị",
    "coxBroadcasting": "CÓ",
    "coxDeviveControl": "KHÔNG",
    "rdMandatory": "Ngày bắt đầu",
    "noRdMandatory": "Ngày kết thúc",
    "startDate": "-",
    "endedDate": "Loại",
    "or": "Chọn thời gian",
    "broadcastingType": "Chọn ngày",
    "ChooseTime": "Lịch trình mới",
    "ChooseDate": "Chỉnh sửa lịch trình",
    "newScheduleList": "Tên",
    "editScheduleList": "Thời gian hiệu lực",
    "listName": "Mô tả",
    "listValidityPeriod": "Hủy",
    "listDescription": "Xác nhận",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm thất bại!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "restoreSuccess": "Danh sách lịch đã được phục hồi thành công",
    "restoreError": "Phục hồi danh sách lịch thất bại",
    "restoreTitleContent": "Thời gian này xung đột với thời gian trong danh sách, vui lòng chọn lại",
    "Enabled": "Kích hoạt",
    "Paused": "Tạm dừng",
    "Title": "Tiêu đề:",
    "Content": "Nội dung:",
    "errorScheduleNameRequired": "Tên nhiệm vụ phải được điền đầy đủ",
    "errorDeviceRequired": "Vui lòng chọn thiết bị đích",
    "deleTitle": "Bạn có chắc chắn muốn xóa nhiệm vụ này không?",
    "loopList": "Danh sách vòng lặp",
    "errorPleaseDateRange": "Vui lòng chọn khoảng thời gian",
    "addError_2009": "Tên bộ lập lịch trùng lặp",
    "conflicts": "Thời gian nhiệm vụ xung đột với nhiệm vụ sau:",
    "Pleaseagain": "Vui lòng nhập lại",
    "errorScheduleName": "Tên nhiệm vụ",
    "errorListName": "Tên bộ lập lịch",
    "today": "Hôm nay",
    "yesterday": "Hôm qua",
    "thisWeek": "Tuần này",
    "lastWeek": "Tuần trước",
    "lastMonth": "Tháng trước",
    "thisMonth": "Tháng này",
    "times": "Lần",
    "TimeConflicts": "Xung đột thời gian",
    "editError_2006": "Không tìm thấy thiết bị",
    "editError_2010": "Tên nhiệm vụ trùng lặp",
    "editError_2100": "Nhiệm vụ đã hết hạn, không thể bắt đầu.",
    "ListTimeExpired": "Thời gian bộ lập lịch đã hết hạn, vui lòng chọn lại",
    "TimeExpired": "Hết thời gian",
    "ControlOption": "Thiếu tùy chọn điều khiển",
    "Pleaseleastone": "Vui lòng chọn ít nhất một tùy chọn điều khiển",
    "Enter": "Nhập",
    "TitleFilled": "Tiêu đề phải được điền đầy đủ",
    "ContentFilled": "Nội dung phải được điền đầy đủ",
    "PleaseMediaFile": "Vui lòng chọn tệp phương tiện",
    "PleaseSchedule": "Vui lòng chọn nhiệm vụ",
    "delTitleScheduleContent": "Nhiệm vụ đã xóa không thể phục hồi.",
    "deleTitleSchedule": "Bạn có chắc chắn muốn xóa nhiệm vụ này không?",
    "deleteScheduleTitle": "Vui lòng chọn nhiệm vụ cần xóa",
    "PleaseFillColumn": "Vui lòng điền tên bộ lập lịch",
    "PleaseDate": "Vui lòng chọn ngày",
    "Previous": "Trước",
    "RemoteControl": "Điều khiển từ xa",
    "taskhasexpired": "Nhiệm vụ này đã hết hạn, vui lòng liên hệ với người tạo để cập nhật thời gian",
    "execute": "Thực hiện",
    "broadcastingList": "Danh sách phát sóng",
    "volumeSuccess": "Đã cài đặt âm lượng thành công",
    "volumeFailed": "Cài đặt âm lượng thất bại"
  },
  "live": {
    "StreamingRoom": "Phòng phát trực tuyến",
    "btnAddNewRoom": "Thêm phòng mới",
    "Steaming": "Phát trực tuyến",
    "Creater": "máy chủ:",
    "Address": "Địa chỉ RTMP:",
    "StreamingURL": "URL phát trực tuyến trực tiếp:",
    "DestinationNMP": "Chọn điểm đến NMP:",
    "stop": "DỪNG",
    "stat": "BẮT ĐẦU",
    "btnCope": "Nhấn để SAO CHÉP",
    "QRcode": "Mã QR",
    "Refresh": "Làm mới",
    "AddNewRoomTitle": "Thêm phòng phát trực tuyến mới",
    "editNewRoomTitle": "Chỉnh sửa phòng phát trực tuyến",
    "roomName": "Tên phòng:",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "delTitleContent": "Bạn có chắc chắn muốn xóa lịch này không?",
    "delTitle": "Xóa?",
    "delCancelButton": "Hủy",
    "delConfirmButton": "Xác nhận",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm thất bại!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "Stopstreaming": "Dừng phát trực tuyến",
    "Startstreaming": "Bắt đầu phát trực tuyến",
    "error2504": "Không thể lấy địa chỉ phát trực tuyến trực tiếp từ máy chủ đa phương tiện",
    "error2505": "Tên phòng phát trực tuyến trùng lặp",
    "error2506": "Thiết bị đã bị chiếm bởi tín hiệu phát trực tuyến khác",
    "error1900": "Tham số truy cập trống",
    "error2503": "Không thể lấy thông tin máy chủ đa phương tiện",
    "error2507": "Địa chỉ phát trực tuyến trực tiếp trùng lặp",
    "copySuccess": "Nội dung đã được sao chép vào clipboard.",
    "copyError": "Trình duyệt không hỗ trợ sao chép tự động",
    "flashControl": "Flash chưa được cài đặt hoặc bật. Vui lòng thử lại sau khi cài đặt hoặc bật Flash.",
    "liveStreaming": "Không tìm thấy nguồn phát trực tuyến trực tiếp.",
    "btnflash": "Cài đặt/Mở",
    "serverAddress": "Địa chỉ máy chủ",
    "addressKey": "Khóa:",
    "watchingAddress": "Địa chỉ xem",
    "audioOnly": "Chỉ âm thanh",
    "enterTheKey": "Khóa phải được điền."
  },
  "guidepages": {
    "next": "Thiết bị điều khiển tiếp theo",
    "next1": "Cố gắng điều khiển tiếp theo",
    "next2": "Truyền phát tiếp theo",
    "next3": "Bắt đầu truyền phát tiếp theo",
    "next4": "Dừng truyền phát tiếp theo",
    "next5": "Truyền phát văn bản tiếp theo",
    "next6": "Cài đặt tác vụ tiếp theo",
    "next7": "Thêm tác vụ mới tiếp theo",
    "next8": "Danh sách lịch sử tiếp theo",
    "next9": "Lưu trữ đám mây tiếp theo",
    "next10": "Phát trực tiếp tiếp theo",
    "next11": "Cài đặt phát trực tiếp tiếp theo",
    "exit": "Thoát",
    "guideContent": "Nội dung hướng dẫn",
    "btnHomepage": "Trang chủ",
    "btnDevices": "Thiết bị",
    "btnBroadcast": "Truyền phát",
    "btnSchedule": "Lịch trình",
    "btnResources": "Tài nguyên",
    "btnStreaming": "Trực tiếp",
    "btnPrevious": "Trước"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/vi.js